import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  mediaController: [
    'runtimeConstant',
    'service',
    '$scope',
    '$rootScope',
    '$filter',
    'authService',
    '$uibModal',
    'EAdminFeatures',
    function (
      runtimeConstant,
      service,
      $scope,
      $rootScope,
      $filter,
      authService,
      $uibModal,
      EAdminFeatures
    ) {
      'use strict';

      function init() {
        $scope.list();
        $scope.sort($scope.sortColumns);
      }

      function newMedia() {
        $scope.newMediaModal = $uibModal.open({
          templateUrl: '/views/partials/newMedia.html',
          controller: 'mediaModalController',
          resolve: {
            service: 'mediaService',
          },
        });
      }

      function list() {
        $scope.itens = null;

        $scope.loading = true;

        service.list().then(
          function (result) {
            $scope.itens = result;
            $scope.loading = false;
            $scope.sort($scope.sortColumns);
          },
          function (error) {
            swal.fire({
              title: error.title,
              text: error.text,
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
            $scope.loading = false;
          }
        );
      }

      function sort(column) {
        var sort = function (a, b) {
          return $scope.sortOperation(a, b, column);
        };
        $scope.itens.sort(sort);
        $scope.sortingColumn = column;
      }

      function sortOperation(a, b, column) {
        var res = 0;

        res = $scope.sortDate(a, b, column);

        if (column.sortOrder === 'desc') {
          return res * -1;
        }

        return res;
      }

      function sortDate(a, b, column) {
        var firstDate, secDate;

        firstDate = $filter('reflect')(a, column.column);
        secDate = $filter('reflect')(b, column.column);

        if (firstDate > secDate) {
          return 1;
        }

        if (firstDate < secDate) {
          return -1;
        }
      }

      function alertUpdateList() {
        $scope.list();
      }

      function run() {
        try {
          $scope.newMediaModal = null;
          $scope.itens = [];
          $scope.sortColumns = service.sortColumns();
          $scope.loading = false;
          $scope.sortingColumn = null;
          $scope.selectedItems = false;

          $rootScope.menus = [
            {
              title: 'MEDIAS',
              icon: 'md md-album',
              ref: 'modules.media.medias',
              visible: function () {
                return authService.isSysAdmin();
              },
              features: [EAdminFeatures.ExportMedia],
              enabled: true,
            },
          ];

          $scope.init = logWrapper(
            init,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.newMedia = logWrapper(
            newMedia,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.list = logWrapper(
            list,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sort = logWrapper(
            sort,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortOperation = logWrapper(
            sortOperation,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortDate = logWrapper(
            sortDate,
            runtimeConstant.isDebugControllersInternals
          );
          $rootScope.alertUpdateList = logWrapper(
            alertUpdateList,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
